import dayjs from "dayjs";

type Admin = { id?: number; name?: string | null; email?: string | null };

export type OrderModeration = {
  approvedAt?: string | null;
  approvedBy?: Admin | null;
  autoApproveAt?: string | null;
  launchAt?: string | null;
  launchedAt?: string | null;
  launchAttempts?: number | null;
  lastError?: string | null;
  rejectedAt?: string | null;
  rejectedBy?: Admin | null;
  rejectReason?: string | null;
};

const adminName = (admin?: Admin | null) => admin?.name || admin?.email || "";

/** In the admin's own time: "14.10 18:30". */
export const formatMoment = (iso?: string | null) =>
  iso ? dayjs(iso).format("DD.MM HH:mm") : "";

/** One line on where an order stands in moderation. */
export const describeModeration = (moderation?: OrderModeration | null) => {
  if (!moderation) return "";
  if (moderation.rejectedAt) {
    const by = adminName(moderation.rejectedBy);
    return `Canceled in moderation${by ? ` by ${by}` : ""}, ${formatMoment(
      moderation.rejectedAt,
    )}${moderation.rejectReason ? `: ${moderation.rejectReason}` : ""}`;
  }
  if (moderation.launchedAt) {
    return `Passed moderation, sent to the contractor ${formatMoment(
      moderation.launchedAt,
    )}`;
  }
  if (moderation.approvedAt) {
    const by = adminName(moderation.approvedBy);
    const approved = `Approved ${by ? `by ${by}` : "automatically"} ${formatMoment(
      moderation.approvedAt,
    )}`;
    if (moderation.lastError) {
      return `${approved}; not sent: ${moderation.lastError}. Next try ${formatMoment(
        moderation.launchAt,
      )}`;
    }
    return `${approved}, going to the contractor`;
  }
  return moderation.autoApproveAt
    ? `Waiting for a moderator; approved automatically at ${formatMoment(
        moderation.autoApproveAt,
      )}`
    : "Waiting for a moderator";
};
